import { render, staticRenderFns } from "./ChatroomFilter.vue?vue&type=template&id=a95a60b2&"
import script from "./ChatroomFilter.vue?vue&type=script&lang=js&"
export * from "./ChatroomFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports